import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import "./StorePage.css";

function StorePage() {
  const [show, setShow] = useState(false);
  useEffect(
    () => setTimeout(() => setShow(true), 2000),
    []
  );
  const [isSpinning, setIsSpinning] = useState(false);

  return (
    <>
      <div className="card">
        <div className="card-header">Store</div>
        <div className="card-body">
          <button type="button" className="btn btn-primary btn-lg">
            New Genres: Requires 3 Silver CobBucks
          </button>
        </div>
      </div>
      <Modal show={show} onHide = {() => setShow(false)}>
        <Modal.Header>
            Spin the Wheel
        </Modal.Header>
        <Modal.Body>
            <button onClick={()=>setIsSpinning(true)}>Spin</button>
                <div className={`${isSpinning ? ('spinning') : ""} spinner-pr`}>
                    <div className="spinner-tl">
                        <span>2x EXP</span>
                    </div>
                    <div className="spinner-tr">
                        <span>LITERAL hacks</span>
                    </div>
                    <div className="spinner-bl">
                        <span>50% Gold Bucks</span>
                    </div>
                    <div className="spinner-br">
                        <span>JUST LEAVE</span>
                    </div>
                </div>
            
        </Modal.Body>
      </Modal>
    </>
  );
}

export default StorePage;
